import BaseView from './_BaseView.js';
import SlideoutMenu from '../components/SlideoutMenu.js';
import TrialAgreement from "../components/TrialAgreement";
import WidgetArea from "../components/WidgetArea";

export default class CommonView extends BaseView {

    setEvents() {
        super.setEvents();
        const body = $('body');

        // main menu
        SlideoutMenu.init();

        $('[data-dropdown]').on('click', function (e) {
            const dropdown = $(this).next('.dropdown-content').toggle('show');

            dropdown.css('left', $(this).position().left);
            //$('.dropdown-content').toggle("show");
            e.stopPropagation();
            return false;
        });

        $('.hamburger').on('click', () => {
            $('.popout').addClass('active');
            return false;
        });


        // if ($('#login').length === 0) {
        //     // check trial
        //     new TrialAgreement();
        // }

        $(document).on('click', function (event) {
            if (!event.target.matches('.multi')) {
                $('.dropdown-content').hide();
            }
            if (!event.target.matches('.hamburger')) {
                $('.popout').removeClass('active');
            }
        });

        // card list toggle
        $('.toggle-list').off('click.tog').on('click.tog', function () {
            const panels = $('.list-toggle');
            panels.toggleClass('list-view');
            const isList = panels.hasClass('list-view');
            localStorage.setItem('listview', isList ? '1' : '0');
            if (isList) {
                $(this).find('i').addClass('jsicon-panel').removeClass('jsicon-hamburger');
            } else {
                $(this).find('i').removeClass('jsicon-panel').addClass('jsicon-hamburger');
            }
        });

        if (localStorage.getItem('listview') === '1') {
            $('.list-toggle').addClass('list-view');
            $('.toggle-list i').addClass('jsicon-panel').removeClass('jsicon-hamburger');
        }

        //Toggle checkboxes
        body.on('click', '[data-toggle]', function () {
            const el = $(this).data('toggle');
            $(el).hide();
            if ($(this).is(':checked')) {
                $(el).show();
            }
        });

        // clearable
        body.on('change.aclear', '.aero-clearable input', function () {
            const $el = $(this);
            if ($el.val() != '') {
                $el.parents('label').addClass('notempty');
            } else {
                $el.parents('label').removeClass('notempty');
            }
        });
        body.on('click.aclearer', '.aero-clearable button', function () {
            $(this).parents('label').find('input').val('').trigger('change');
            return false;
        });

        // logout
        $('#logout').on('click', function () {
            $.ajax({
                url: $(this).attr('href'),
                method: 'post'
            }).fail(function () {
                window.location.reload();
            }).done(function () {
                window.location = '/login';
            });
            return false;
        });

        // tabs
        body.on('click', '.tabs li > a', function () {
            const tabs = $(this).parents('.tabs');
            const id = $(this).attr('href');

            tabs.find('li').removeClass('active');
            tabs.next('.tabs-content').find('.content').removeClass('active');

            $(this).parents('li').addClass('active');
            $(id).addClass('active');
            $(id).find('.chart-container').trigger('activate');
            return false;
        });

        $('.widget-area').each(function () {
            WidgetArea.init($(this));
        });
    }
}
